import { DataBean } from "../DataBean";

export class ObligationForFinancial extends DataBean {



    public async setObligationForFinancialMovementTax(idFinancialMovementTax: any, financialMovementDate: any, obIDDocument: any, obDocumentDate: any, idEmployee: any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "com.quickdataerp.bean.accountant.AccountantDocument_setObligationForFinancialMovementTax_Number_java.util.Date_Number_java.util.Date_Number", [idFinancialMovementTax, financialMovementDate, obIDDocument, obDocumentDate, idEmployee]);
    }

}